<template>
  <div id="app">
    <template v-if="inMaintenance">
      <ComingSoon />
    </template>
    <XHeader v-show="!disableLayout" />
    <div :class="['main', hasBgCls ? 'bgCls' : '']">
      <router-view />
    </div>
    <Login v-if="showLogin" @loginSuccess="onLoginSuccess" @loginClose="onLoginClose" />
    <MiniCar v-if="showMiniCar" />
    <button id="backTop" class="btn btn--rounded back-to-top back-to-top--secondary hide" type="button" title="转到页面顶部">
      <svg class="svg-inline arrow-big" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="14" height="8" viewBox="0 0 14 8"><path fill="#000" fill-rule="evenodd" d="M7 6.99L13.338.13c.362-.393.905.195.543.587L7.27 7.873a.362.362 0 0 1-.334.123.38.38 0 0 1-.209-.123L.12.717C-.242.325.3-.263.662.13L7 6.991z"></path></svg>
      <svg class="svg-inline arrow-big arrow-big--white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="14" height="8" viewBox="0 0 14 8"><path fill="#fff" fill-rule="evenodd" d="M7 6.99L13.338.13c.362-.393.905.195.543.587L7.27 7.873a.362.362 0 0 1-.334.123.38.38 0 0 1-.209-.123L.12.717C-.242.325.3-.263.662.13L7 6.991z"></path></svg>
    </button>
    <XFooter v-show="!disableLayout" />
    <!-- Notification -->
    <template v-if="notice && notice.pc && notice.pc.pop && notice.pc.pop.status == 1">
      <Dialog :show="!!dialogPc" wrapCls="notice__wrap" @hide="closeNoticePc">
        <a class="notice_link" :href="notice.pc.pop.pop_url || 'javascript:void(0)'">
          <img :src="notice.pc.pop.pop_img" />
        </a>
      </Dialog>
    </template>
    <template v-if="notice && notice.h5 && notice.h5.pop && notice.h5.pop.status == 1">
      <Dialog :show="!!dialogH5" wrapCls="notice__wrap" @hide="closeNoticeH5">
        <a class="notice_link" :href="notice.h5.pop.pop_url || 'javascript:void(0)'">
          <img :src="notice.h5.pop.pop_img" />
        </a>
      </Dialog>
    </template>
    <!-- 组件弹框 -->
    <template>
      <Dialog :show="showEbaDialog.dialog" wrapCls="notice__wrap" @hide="closeNoticeEba">
        <a class="notice_link" href="javascript:void(0)">
          <img :src="showEbaDialog.url" />
        </a>
      </Dialog>
    </template>
    <!-- 提示弹框 -->
    <div class="toast" v-if="isToast && siteConfig">
      <div class="toast_msg">
        {{siteConfig.JUMPTEXT.text}}
      </div>
    </div>
	<!-- 隐私协议弹框 -->
	<div class="toast" style="background: #0009;" v-if="$store.state.isShowDeal&&$route.path!='/privacy'">
	  <div class="toast_msg dealTip_msg" style="background: #fff;">
			<div class="dealTip" >
				<div class="dealTip-title" >用户隐私保护提示 </div>
				<div class="dealTip-text" >请仔细阅读<span @click="toDeal" class="deal-name">《Sisley希思黎隐私保护协议》</span>，如你同意 《Sisley希思黎隐私保护协议》，请点击“同意”开始使用。</div>
				<div class="dealTip-btns-view">
					<div class="dealTip-btns" >
						<div class="dealTip-btn dealTip-btn1" @click="dealReject " >拒绝</div>
						<div class="dealTip-btn dealTip-btn2" @click="dealAgree" >同意</div>
					</div>
				</div>
			</div>
	  </div>
	</div>
  </div>
</template>

<script>
import ComingSoon from "./components/ComingSoon";
import XHeader from "./components/Header";
import XFooter from "./components/Footer";
import Dialog from '@/components/Dialog';
import utils from "@/utils";
import types from "@/store/types";
import axios from 'axios';
import api from '@/utils/api';
export default {
  // eslint-disable-next-line vue/no-unused-components
  components: { ComingSoon, XHeader, XFooter, Dialog, Login: () => import("@/components/Login"), MiniCar: () => import("@/components/MiniCar") },
  data() {
    return {
      hasBgCls: false,
      pageShow: true,
      dialogPc: false,
      dialogH5: false,
    };
  },
  created() {
    this.onPageScroll = utils.throttle(this.onPageScroll, 200);
    // 
    this.$store.dispatch(types.NOTICE);
    this.setUrlParams();
  },
  mounted() {
    setTimeout(() => {
      this.initScroll();
    }, 500);
    // 显示通知
    if (this.notice) this.initNotice();
  },
  updated() {
    if (this.notice) this.initNotice();
  },
  methods: {
    setUrlParams(){
      let params = ["channel", "entrance"];
      params.map(param => {
        if(this.getUrlParam(param)){
          localStorage.setItem(param, this.getUrlParam(param))
        }    
      })
    },
    getUrlParam(name) {
      //封装方法           
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); 
      //构造一个含有目标参数的正则表达式对象           
      var r = window.location.search.substr(1).match(reg); 
      //匹配目标参数          
      if (r != null) return unescape(r[2]);     
      return null;  //返回参数值        
    },

    getMemberTitle(sex) {
      return { "M": "Mr", "F": "Mrs"}[sex];
    },
    getMemberLevel(levelIndex) {
      return ['not_member', 'orchidée', 'gold', 'platinum'][levelIndex] || '';
    },
    // 登录成功
    onLoginSuccess() {
      // 
    },
    // 关闭登录
    onLoginClose() {
      // 
    },
    // 注册页面滚动事件
    initScroll() {
      this.backTop = document.getElementById("backTop");
      if (!this.backTop) return;
      this.backTop.addEventListener("click", this.backToTop, false);
      window.addEventListener("scroll", this.onPageScroll, false);
      this.$once("hook:beforeDestroy", () => {
        window.removeEventListener("scroll", this.onPageScroll, false);
      });
    },
    // 页面滚动事件处理: “回到顶部”按钮显示隐藏状态控制
    onPageScroll() {
      let st = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop;
      if (st >= 900 && this.backTop.className.indexOf("hide") != -1) {
        this.backTop.className = this.backTop.className.replace(/hide/g, "");
      } else if (st < 900 && this.backTop.className.indexOf("hide") == -1) {
        this.backTop.className += " hide";
      }
    },
    // 回到顶部
    backToTop() {
      // 耗时, 频率, 高度
      var duration = 500, interval = 1000/60, st = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop;
      var step = (st / duration) * interval;
      var timer = setInterval(() => {
        let currST = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop;
        if (currST === 0) {
          console.info('[info]:: clearInterval');
          timer && clearInterval(timer);
          return;
        }
        currST -= step;
        document.documentElement.scrollTop = currST;
        document.body.scrollTop = currST;
      }, interval);
    },
    // 初始化通知弹窗
    initNotice() {
      if(utils.isMobile()) {
        if(this.notice.h5.pop.status == 1){
          let lastNoticeShowTimeH5 = utils.getItem("noticeTimeH5");
          this.setNoticeTime(lastNoticeShowTimeH5, 'noticeTimeH5', 'dialogH5')
        }
      }else {
        if(this.notice.pc.pop.status == 1){
          let lastNoticeShowTimePc = utils.getItem("noticeTimePc");
          this.setNoticeTime(lastNoticeShowTimePc, 'noticeTimePc', 'dialogPc')
        }
      }
    },
    setNoticeTime(last, key, dialog) {
      let today = utils.dateFormat(new Date, 'YYYY-MM-dd');
      if (last != today) {
        setTimeout(() => {
          utils.setItem(key, today);
          this[dialog] = !0;
        }, 2 * 1000);
      }
    },
    // 关闭通知弹窗
    closeNoticePc() {
      this.dialogPc = !1;
    },
    closeNoticeH5() {
      this.dialogH5 = !1;
    },
    // 关闭组件eba弹框
    closeNoticeEba() {
      this.$store.commit("setEbaDialog", { dialog: false, url: '' });
    },
	/**隐私协议跳转 */
	toDeal(){
		console.log("==隐私协议")
		this.$router.push({
			path:"/privacy"
		})
		 // this.$store.commit('setIsShowDeal',false)
	},
	/**隐私协议确认 */
	dealAgree(){
		 api[types.USER_AUTH]();
		 this.$store.commit('setIsShowDeal',false)
	},
	/**隐私协议拒绝 */
	dealReject(){
		this.$store.commit('setIsShowDeal',false)
	}
  },
  computed: {
    showLogin() {
      return this.$store.state.enableLogin;
    },
    disableLayout() {
      return this.$store.state.disableLayout;
    },
    notice() {
      return this.$store.state.notice;
    },
    showMiniCar() {
      return this.$store.state.enableMiniCar;
    },
    showEbaDialog() {
      return this.$store.state.ebaDialog;
    },
    isToast() {
      return this.$store.state.isToast;
    },
    siteConfig() {
      return this.$store.state.siteConfig;
    },
    inMaintenance() {
      let flag = false;
      try {
        if(this.$store.state.siteConfig?.IS_TENANCE?.tenance) {
          let obj = JSON.parse(this.$store.state.siteConfig.IS_TENANCE.tenance);
          flag = obj.flag
        } else {
          flag = false
        }
      } catch (error) {
        flag = false
      }
      return flag;
    }
  },
  watch: {
    $route(to) {
      this.hasBgCls = /^\/myaccount/.test(to.fullPath);
    },
    isToast(val) {
      if(val) {
        setTimeout(() => {
          this.$store.commit("setToast", false);
        },parseInt(this.siteConfig.JUMPTIME.time))
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.main { min-height: 100vh; }
.bgCls {
  background: url(./assets/imgs/account-bg.png) 0 0 no-repeat;
}
// 通知
::v-deep .notice__wrap .dialog-container {
  width: 300px; height: 385px; overflow: hidden; top: calc(50% + 60px); box-shadow: 0 0 20px 0 rgba(0,0,0,0.2);
  .dialog-body {
    flex-direction: column; justify-content: flex-start; align-items: center;
    .notice_link { display: block; width: 100%; height: 100%; }
  }
}
.loading__wrapper {
  display: none;
  .loading__mask {
    position: fixed; top: 0; left: 0; bottom: 0; right: 0; z-index: 9999; width: 100%; height: 100%; background: rgba(0, 0, 0, 0.3);
  }
  .loading__main {
    position: fixed; top: 50%; left: 50%; z-index: 10000; transform: translate(-50%, -50%);
    display: flex; flex-direction: column; justify-content: center; align-items: center;
    .loading { width: 100px; height: 100px; position: relative; margin: 0 auto; margin-top: 100px; }
    .loading span { display: inline-block; width: 20px; height: 20px; border-radius: 50%; background: white; position: absolute; animation: loading 1.04s ease infinite; }
    @keyframes loading {
      0% { transform: scale(1.2); opacity: 1; }
      100% { transform: scale(.3); opacity: 0.5; }
    }
    .loading span:nth-child(1) { left: 0; top: 50%; margin-top: -10px; animation-delay: 0.13s; }
    .loading span:nth-child(2) { left: 14px; top: 14px; animation-delay: 0.26s; }
    .loading span:nth-child(3) { left: 50%; top: 0; margin-left: -10px; animation-delay: 0.39s; }
    .loading span:nth-child(4) { top: 14px; right: 14px; animation-delay: 0.52s; }
    .loading span:nth-child(5) { right: 0; top: 50%; margin-top: -10px; animation-delay: 0.65s; }
    .loading span:nth-child(6) { right: 14px; bottom: 14px; animation-delay: 0.78s; }
    .loading span:nth-child(7) { bottom: 0; left: 50%; margin-left: -10px; animation-delay: 0.91s; }
    .loading span:nth-child(8) { bottom: 14px; left: 14px; animation-delay: 1.04s; }
  }
  &.show { display: block; }
}
.dealTip{
	color: #333;
	padding: 20px 40px;
	.dealTip-title{
		font-size: 16px;
		margin-bottom: 10px;
		text-align: center;
	}
	.dealTip-text{
		.deal-name{
			text-decoration: underline;
		}
	}
	.dealTip-btns-view{
		
	}
	.dealTip-btns{
		padding-top: 30px;
		display: flex;
		justify-content: space-around;
		padding-bottom: 20px;
		.dealTip-btn{
			display: inline-block;
			    vertical-align: middle;
			    padding: .8125rem 1.875rem;
			    -webkit-appearance: none;
			    border-radius: 1.375rem;
			    -webkit-transition: background-color .25s ease-out, color .25s ease-out;
			    transition: background-color .25s ease-out, color .25s ease-out;
			    font-family: HelveticaNeueLTW05-75Bold, arial, sans-serif;
			    font-size: .625rem;
			    line-height: 1;
			    letter-spacing: .0625rem;
			    text-align: center;
			    cursor: pointer;
			    text-decoration: none;
			    text-transform: uppercase;
			    background: transparent;
			    border: .0625rem solid #cacaca;
			    color: #000;
		}
		.dealTip-btn1{
			
		}
		.dealTip-btn2{
			background-color: #000;
			color: #fff;
			
		}
		
	}
}
@media screen and (min-width: 64em) {
  // 通知
  ::v-deep .notice__wrap .dialog-container {
    width: 600px; height: 400px;
    .dialog-body {
      flex-direction: column; justify-content: flex-start; align-items: center;
    }
  }
}
</style>

<style>
@import "../src/assets/common.css";
#app {
  font-family: HelveticaNeueLTW05-45Light, "Avenir", Helvetica, Arial,
    sans-serif;
  font-weight: 400;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #575757;
}
/* 公告栏样式修复 Start */
.has-notice + .main .home-wrapper { margin-top: 59px; }
.has-notice + .main .hair-rituel__wrapper { margin-top: 59px; }
.has-notice + .main .landing-wrapper { margin-top: 59px; }
.has-notice + .main .category-wrap { margin-top: 69px; }
.has-notice + .main .pdp-wrap { margin-top: 59px; }
.has-notice + .main .pdp-wrap .m-product-details__main .info-box.fixed { top: 129px; }
.has-notice + .main .my-account { margin-top: 59px; }
.has-notice + .main .personalized_samples__wrap { margin-top: 59px; }
.has-notice + .main .gift_customization___wrap { margin-top: 59px; }
.has-notice + .main .page__wrap { margin-top: 116px; }
.has-notice + .main .store_wrapper { margin-top: 59px; }
.has-notice + .main .terms__wrap { margin-top: 59px; }
.has-notice + .main .legal__wrap { margin-top: 59px; }
.has-notice + .main .privacy__wrap { margin-top: 59px; }
.has-notice + .main .sitemap__wrap { margin-top: 59px; }
.toast{
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 99;
}
.toast_msg{
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 99;
  background: #333;
  color: #fff;
  width: 59%;
  padding: 5px 10px;
  border-radius: 5px;
  &.dealTip_msg{
	  max-width: 320px;
	  width: 90%;
  }
}
@media screen and (min-width: 48em) {
  .has-notice + .main .pdp-wrap { margin-top: 79px; }
}
@media screen and (min-width: 64em) {
  /* .has-notice + .main .home-wrapper :first-child.base-swiper {
    height: calc(100vh - 59px);
  } */
  .has-notice + .main .landing-wrapper,
  .has-notice + .main .category-wrap,
  .has-notice + .main .pdp-wrap,
  .has-notice + .main .my-account,
  .has-notice + .main .personalized_samples__wrap,
  .has-notice + .main .gift_customization___wrap,
  .has-notice + .main .page__wrap,
  .has-notice + .main .store_wrapper,
  .has-notice + .main .terms__wrap,
  .has-notice + .main .legal__wrap,
  .has-notice + .main .privacy__wrap,
  .has-notice + .main .sitemap__wrap { margin-top: 0; }
}
/* 公告栏样式修复 End */
@font-face {
  font-family: 'iconfont';  /* project id 1816085 */
  src: url('//at.alicdn.com/t/font_1816085_0uxdjcamj0dd.eot');
  src: url('//at.alicdn.com/t/font_1816085_0uxdjcamj0dd.eot?#iefix') format('embedded-opentype'),
  url('//at.alicdn.com/t/font_1816085_0uxdjcamj0dd.woff2') format('woff2'),
  url('//at.alicdn.com/t/font_1816085_0uxdjcamj0dd.woff') format('woff'),
  url('//at.alicdn.com/t/font_1816085_0uxdjcamj0dd.ttf') format('truetype'),
  url('//at.alicdn.com/t/font_1816085_0uxdjcamj0dd.svg#iconfont') format('svg');
}
.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
/* 修改下拉组件的样式 */
.multiselect .multiselect__select::before {
  content: '\e661';
  font-family: "iconfont" !important;
  font-size: 10px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: inline-block; transform: scale(0.5); height: 45px; line-height: 45px;
  position: absolute; top: 0px; right: 10px; margin-top: 0; border: none;
}
/* a {
  color: #575757 !important;
  text-decoration: none;
} */
.full-width { width: 100%; max-width: 100%; }
.c-button {
  display: inline-block;
  vertical-align: middle;
  padding: 0.8125rem 1.875rem;
  -webkit-appearance: none;
  border-radius: 1.375rem;
  transition: background-color 0.25s ease-out, color 0.25s ease-out;
  font-family: HelveticaNeueLTW05-75Bold, arial, sans-serif;
  font-size: 0.625rem;
  line-height: 1;
  letter-spacing: 0.0625rem;
  text-align: center;
  cursor: pointer;
  text-decoration: none;
  text-transform: uppercase;
  background: transparent;
  border: 0.0625rem solid #cacaca;
  color: #000;
}
.c-button--disabled:not(.c-button--inactive), .c-button[disabled]:not(.c-button--inactive) {
  opacity: 0.65;
  cursor: not-allowed;
}
.c-button--primary {
  display: inline-block;
  vertical-align: middle;
  padding: 0.8125rem 1.875rem;
  -webkit-appearance: none;
  border-radius: 1.375rem;
  transition: background-color 0.25s ease-out, color 0.25s ease-out;
  font-family: HelveticaNeueLTW05-75Bold, arial, sans-serif;
  font-size: 0.625rem;
  line-height: 1;
  letter-spacing: 0.0625rem;
  text-align: center;
  cursor: pointer;
  text-decoration: none;
  text-transform: uppercase;
  background: #000;
  border: 0.0625rem solid #000;
  color: #fff;
}
@media screen and (min-width: 48em) {
  .c-button--primary:hover {
    text-decoration: none;
    background-color: #fff;
    border-color: #cacaca;
    color: #000;
    outline: none;
  }
}
.c-button--bold { font-weight: 700; }
.c-button--rounded {
  border-radius: 50%;
  padding: 0;
  width: 2.375rem;
  height: 2.375rem;
  position: relative;
  background: transparent;
  border-color: #cacaca;
  color: #000;
}
.c-input {
  height: 2.8125rem;
  border-radius: 1.40625rem;
  font-size: 0.8125rem;
  font-family: HelveticaNeueLTW05-45Light, arial, sans-serif;
  padding: 0.875rem 1rem 0.8125rem;
  background: #fff;
  border: 0.0625rem solid #cacaca;
  color: #cacaca;
  color: #575757;
}
.c-input--fullwidth { width: 100%; }
.center-xs { justify-content: center; text-align: center; }
.multiselect .multiselect__content-wrapper .multiselect__content .multiselect__element .multiselect__option--selected { background: #F6F6F6; color: #575757; }
.multiselect .multiselect__content-wrapper .multiselect__content .multiselect__element .multiselect__option--selected.multiselect__option--highlight { background: #F6F6F6; }
/* 蒙版层 */
.modal-background {
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 99;
}
.no-scroll { height: 100%; overflow: hidden; }
.form-group { margin-bottom: 1.5625rem; position: relative; }
.back-to-top { position: fixed; right: 1.0625rem; bottom: 1.0625rem; z-index: 10; background-color: #fff; }
.back-to-top .arrow-big { transform: rotate(180deg) translate(50%,50%); }
.back-to-top--secondary .arrow-big { position: absolute; z-index: 11; }
.back-to-top--secondary .arrow-big--white { z-index: 0; }
.back-to-top--secondary:hover { background: #000; }
.back-to-top--secondary:hover .arrow-big--white { z-index: 12; }
@media screen and (min-width: 48em) {
  .back-to-top { right: 3.875rem; bottom: 1.875rem; }
}
@media screen and (min-width: 64em) {
  .back-to-top { right: 1.875rem; bottom: 2.5rem; }
}
@media screen and (min-width: 75em) {
  .back-to-top { right: 3.125rem; bottom: 3.125rem; }
}
</style>
